// extracted by mini-css-extract-plugin
export default {"accountText":"AccountPage_accountText__l21Ke","accountLinks":"AccountPage_accountLinks__TfiOD","divider":"AccountPage_divider__ZqW2k"};